// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FAVZ","left":"styles_left__2soEP"};